import { useState } from "react";
import { supabase } from "../lib/supabase";
import logo from "../assets/dzears.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (email.toLowerCase() !== "dylanzajac@computers4people.org") {
      setError("Access restricted.");
      setLoading(false);
      return;
    }
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin + "/dashboard" },
    });
    if (error) {
      setError(error.message);
    } else {
      setSent(true);
    }
    setLoading(false);
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <img src={logo} alt="Logo" className="h-10 w-auto mb-10 opacity-80" />

      {sent ? (
        <div className="text-center max-w-sm">
          <h1 className="text-2xl font-bold text-black mb-3">Check your email</h1>
          <p className="text-sm text-gray-400 leading-relaxed">
            We sent a magic link to <strong className="text-gray-600">{email}</strong>.
            Click it to sign in — no password needed.
          </p>
        </div>
      ) : (
        <div className="w-full max-w-sm">
          <h1 className="text-3xl font-bold text-black mb-2 text-center">Sign in</h1>
          <p className="text-sm text-gray-400 text-center mb-8">We'll send you a magic link</p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <input
              type="email"
              required
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-gray-400 transition-colors"
            />
            {error && <p className="text-xs text-red-500">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-black text-white text-sm font-medium py-3 rounded-xl hover:bg-gray-800 transition-colors disabled:opacity-50"
            >
              {loading ? "Sending…" : "Send magic link"}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
